<div class="overlay" [class.hide]="isFocussed">
    @if (icon === 'dvds') {
        <img class="dvds-icon" src="/assets/images/logo-small.png" />
    }
    @if (icon === 'own') {
        <i class="fa-duotone fa-house-user"></i>
    }
    @if (icon === 'next') {
        <i class="fa-duotone fa-arrow-right"></i>
    }
    @if (icon === 'none') {
        <i class="fa-duotone fa-xmark"></i>
    }
    @if (icon === 'work') {
        <i class="fa-duotone fa-person-digging"></i>
    }
    @if (addressVisible) {
        <span>{{ fc.value | locationFormat }}</span>
    }
</div>
<input
    [class.visible]="isFocussed"
    [matAutocomplete]="autoComplete"
    [placeholder]="placeholder"
    [formControl]="fcSearch"
    (focus)="isFocussed = true"
    (blur)="isFocussed = false"
    type="text"
    matInput />
<mat-autocomplete
    class="address-autocomplete"
    #autoComplete="matAutocomplete"
    (optionSelected)="optionSelected($event)"
    (opened)="updateAddresses()"
    autoActiveFirstOption>
    @let search = (fcSearch.value || '').trim();

    @if (fc.value) {
        <mat-option [value]="fc.value"><b>Huidig:</b> {{ fc.value }}</mat-option>
    }

    @if (!search) {
        @if (main.planning.location?.length > 0) {
            <mat-option [value]="main.planning.location">
                <div class="row flex-nowrap">
                    <div class="col-auto d-flex align-items-center pr-0">
                        <i class="fa-duotone fa-person-digging"></i>
                    </div>
                    <div class="col ellipsis">
                        {{ main.planning.location }}
                    </div>
                </div>
            </mat-option>
        }
        @if (driverAddress) {
            <mat-option [value]="driverAddress">
                <div class="row flex-nowrap">
                    <div class="col-auto d-flex align-items-center pr-0">
                        <i class="fa-duotone fa-house-user"></i>
                    </div>
                    <div class="col ellipsis">
                        {{ driverAddress }}
                    </div>
                </div>
            </mat-option>
        }
        @if (worksiteAddress) {
            <mat-option [value]="worksiteAddress">
                <div class="row flex-nowrap">
                    <div class="col-auto d-flex align-items-center pr-0">
                        <i class="fa-duotone fa-person-digging"></i>
                    </div>
                    <div class="col ellipsis">
                        {{ worksiteAddress }}
                    </div>
                </div>
            </mat-option>
        }
        <mat-option [value]="companyAddress">
            <div class="row flex-nowrap">
                <div class="col-auto d-flex align-items-center pr-0">
                    <img class="dvds-icon" src="/assets/images/logo-small.png" />
                </div>
                <div class="col ellipsis">
                    {{ environment.companyAddress.street }} {{ environment.companyAddress.housenumber }},
                    {{ environment.companyAddress.town }}
                </div>
            </div>
        </mat-option>
        <mat-option value="none">
            <div class="row flex-nowrap">
                <div class="col-auto d-flex align-items-center pr-0">
                    <i class="fa-duotone fa-xmark"></i>
                </div>
                <div class="col ellipsis">Geen</div>
            </div>
        </mat-option>
        <mat-option value="next">
            <div class="row flex-nowrap">
                <div class="col-auto d-flex align-items-center pr-0">
                    <i class="fa-duotone fa-arrow-right"></i>
                </div>
                <div class="col ellipsis">{{ isOrigin ? 'Vorige' : 'Volgende' }} transportregel</div>
            </div>
        </mat-option>
    } @else if (search.length < 3) {
        <mat-option disabled> Typ minimaal 3 karakters om te zoeken </mat-option>
    }
    @for (option of addresses; track option) {
        <mat-option [value]="option">
            {{ option }}
        </mat-option>
    }
</mat-autocomplete>
